import classnames from 'classnames'
import type React from 'react'
import './button.css'

export default function Button({
  children,
  onClick,
  base = false,
  small = false,
  disabled = false,
  className = undefined,
}: {
  children: React.ReactNode
  onClick?: () => void
  small?: boolean
  base?: boolean
  disabled?: boolean
  className?: string
}) {
  const buttonClasses = classnames({
    'button-primary': !small && !base,
    'button-primary--small': small && !base,
    button: base,
    'opacity-50 cursor-not-allowed': disabled,
    [className || '']: className,
  })

  return (
    <button className={buttonClasses} type={'button'} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  )
}
